// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { get } from 'crm_data/api/ImmutableAPI';
export function fetchSequenceStepSummary(sequenceStepEnrollmentId) {
  return get(`sequences/v2/step-enrollments/${sequenceStepEnrollmentId}/extended-summary`);
}
export function fetchSequenceEnrollment(sequenceEnrollmentId) {
  return get(`sequences/v1/enrollment/${sequenceEnrollmentId}`);
}